import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            热度榜单
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            实时更新的影视热度排行，看看本周大家都在看什么
          </p>
        </div>

        <div className="bg-background-50 rounded-3xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 md:px-8 py-4 md:py-5 hover:bg-primary-50/30 transition-colors cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-primary-400 text-white' :
                item.rank === 3 ? 'bg-primary-300 text-white' :
                'bg-background-100 text-foreground-500'
              }`}>
                <span className="font-heading text-lg font-bold">{item.rank}</span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap flex-shrink-0">
                    {item.type}
                  </span>
                </div>
                <div className="text-sm text-foreground-500 mt-0.5">{item.hot}</div>
              </div>

              <span className={`text-xs font-semibold whitespace-nowrap flex-shrink-0 ${
                item.tagUp ? 'text-accent-500' : 'text-foreground-400'
              }`}>
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}